import React from "react";
import {
  Grid,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
} from "@mui/material";

const FitnessInfo = ({ formData, handleInputChange, handleBooleanChange }) => {
  return (
    <>
      {/* Main Question */}
      <Grid item xs={12}>
        <Typography variant="body1">Pratiquez-vous la musculation ?</Typography>
        <RadioGroup
          row
          name="musculationQuestion"
          value={formData.musculationQuestion ? "true" : "false"} // Convert boolean to string
          onChange={handleBooleanChange} // Pass event handler directly
        >
          <FormControlLabel value="true" control={<Radio />} label="Oui" />
          <FormControlLabel value="false" control={<Radio />} label="Non" />
        </RadioGroup>
      </Grid>
      {formData.musculationQuestion && (
        <>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Années d'expérience"
              name="muscuAnneeExperience"
              type="number"
              value={formData.muscuAnneeExperience}
              onChange={handleInputChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Développé Couché (kg)"
              name="muscuDeveloppeCouche"
              type="number"
              value={formData.muscuDeveloppeCouche}
              onChange={handleInputChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Squat (kg)"
              name="muscuSquat"
              type="number"
              value={formData.muscuSquat}
              onChange={handleInputChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Tractions (répétitions)"
              name="muscuTractions"
              type="number"
              value={formData.muscuTractions}
              onChange={handleInputChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Press Overhead (kg)"
              name="muscuPressOverhead"
              type="number"
              value={formData.muscuPressOverhead}
              onChange={handleInputChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">
              Pratiquez-vous d'autres activités physiques ?
            </Typography>
            <RadioGroup
              row
              name="muscuAutreActivite"
              value={formData.muscuAutreActivite ? "true" : "false"} // Convert boolean to string
              onChange={handleBooleanChange} // Pass event handler directly
            >
              <FormControlLabel value="true" control={<Radio />} label="Oui" />
              <FormControlLabel value="false" control={<Radio />} label="Non" />
            </RadioGroup>
          </Grid>
          {formData.muscuAutreActivite && (
            <Grid item xs={12}>
              <TextField
                label="Liste des Activités"
                name="muscuListeAutreActivite"
                value={formData.muscuListeAutreActivite}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
          )}
        </>
      )}
      {!formData.musculationQuestion && (
        <>
          <Grid item xs={12}>
            <Typography variant="body1">
              Souhaitez-vous commencer d'autres activités physiques ?
            </Typography>
            <RadioGroup
              row
              name="noMuscuAutreActivite"
              value={formData.noMuscuAutreActivite ? "true" : "false"} // Convert boolean to string
              onChange={handleBooleanChange} // Pass event handler directly
            >
              <FormControlLabel value="true" control={<Radio />} label="Oui" />
              <FormControlLabel value="false" control={<Radio />} label="Non" />
            </RadioGroup>
          </Grid>
          {formData.noMuscuAutreActivite && (
            <Grid item xs={12}>
              <TextField
                label="Liste des Activités Souhaitées"
                name="noMuscuListeAutreActivite"
                value={formData.noMuscuListeAutreActivite}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <TextField
              label="Souhaitez-vous commencer la musculation ?"
              name="noMuscuSouhaitCommencerMuscu"
              value={formData.noMuscuSouhaitCommencerMuscu}
              onChange={handleInputChange}
              fullWidth
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default FitnessInfo;
